// OR Variant System — Amazon-style вывод вариантов на странице товара.
// Данные приходят из snippets/or-variant-system.liquid (window.OrgoVariantData):
//   defaults  — заголовок и галерея товара (fallback),
//   variants  — по каждому варианту: fullTitle / descriptionHtml / gallery (null, если метаполе пусто).
// При клике по тайлу варианта подменяет заголовок, описание и галерею без перезагрузки;
// цену/скидку обновляет существующий обработчик тайлов в product-page.liquid — его не трогаем.
(function () {
    'use strict';

    function escapeAttr(value) {
        return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    // Превентивная проверка остатков перед /cart/add.js (как в реальных магазинах):
    // maxQty варианта приходит из or-variant-system.liquid (null = не отслеживается),
    // текущее количество в корзине берём из /cart.js. Возвращает Promise<{ok, message}>.
    // Сообщение показывает OrgoShowAtcMessage (тост, определён в theme.liquid).
    window.OrgoValidateAdd = function (variantId, qty) {
        var data = window.OrgoVariantData;
        var v = data && data.variants && data.variants[String(variantId)];
        var max = v ? v.maxQty : null;
        if (max == null) return Promise.resolve({ ok: true });
        if (max <= 0) return Promise.resolve({ ok: false, message: 'Sorry, this option is sold out.' });

        return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var inCart = 0;
                (cart.items || []).forEach(function (item) {
                    if (String(item.variant_id) === String(variantId)) inCart += item.quantity;
                });
                if (inCart + qty <= max) return { ok: true };
                if (inCart >= max) {
                    return { ok: false, message: 'You already have all ' + max + ' available in your cart.' };
                }
                var msg = 'Only ' + max + ' left in stock' + (inCart > 0 ? ' — you already have ' + inCart + ' in your cart.' : '.');
                return { ok: false, message: msg };
            })
            .catch(function () { return { ok: true }; }); // /cart.js недоступен — пусть решает сервер
    };

    function init() {
        var data = window.OrgoVariantData;
        if (!data || !data.variants) return;

        // Ключ текущей галереи, чтобы не пересобирать DOM, когда оба варианта
        // используют одну и ту же (дефолтную) галерею товара.
        var currentGalleryKey = 'default';
        // Уже применённый вариант: повторный клик по выбранному тайлу — no-op,
        // ничего не перерисовываем.
        var appliedVariantId = null;

        function galleryFor(variantId) {
            var v = data.variants[variantId];
            if (v && v.gallery && v.gallery.length) {
                return { key: String(variantId), images: v.gallery };
            }
            return { key: 'default', images: data.defaults.gallery };
        }

        function rebuildGallery(images) {
            var slidesWrap = document.querySelector('.organo-republic-slides');
            if (!slidesWrap) return;

            var thumbsWrap = document.querySelector('.organo-republic-thumbnails');
            // Лайтбокс перенесён в <body> скриптом галереи — ищем по id глобально.
            var lightbox = document.getElementById('organo-republic-lightbox');

            var slidesHtml = '';
            var thumbsHtml = '';
            var lbThumbsHtml = '';

            images.forEach(function (img, i) {
                var alt = escapeAttr(img.alt);
                // Фото вариантов грузятся лениво: до первого выбора варианта их нет в DOM,
                // а при создании <img> ставим loading="lazy" для неактивных слайдов.
                slidesHtml += '<div class="organo-republic-slide">' +
                    '<img src="' + img.src + '"' +
                    (img.srcset ? ' srcset="' + escapeAttr(img.srcset) + '" sizes="(max-width: 550px) 100vw, 500px"' : '') +
                    ' data-zoom-src="' + img.zoom + '" alt="' + alt + '"' + (i > 0 ? ' loading="lazy"' : '') + '>' +
                    '</div>';
                thumbsHtml += '<div class="organo-republic-thumbnail"><img src="' + img.thumb + '" alt="' + alt + '" loading="lazy"></div>';
                lbThumbsHtml += '<button type="button" class="organo-republic-lightbox__thumb' + (i === 0 ? ' active' : '') + '" data-index="' + i + '">' +
                    '<img src="' + img.lbThumb + '" alt="' + alt + '" loading="lazy">' +
                    '</button>';
            });

            slidesWrap.innerHTML = slidesHtml;
            if (thumbsWrap) thumbsWrap.innerHTML = thumbsHtml;
            if (lightbox) {
                var lbThumbs = lightbox.querySelector('.organo-republic-lightbox__thumbs');
                if (lbThumbs) lbThumbs.innerHTML = lbThumbsHtml;
                var lbTotal = lightbox.querySelector('.organo-republic-lightbox__counter-total');
                if (lbTotal) lbTotal.textContent = images.length;
            }

            if (window.OrgoReinitProductGallery) window.OrgoReinitProductGallery();
        }

        // Line item property для корзины: видимое имя "Variant" + полный тайтл.
        // Скрытые формы (mobile/desktop/sticky) держим в синхроне на случай, если
        // отправка пойдёт через универсальный FormData-обработчик из theme.liquid.
        function syncPropertyInputs(fullTitle) {
            document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
                var input = form.querySelector('input[name="properties[Variant]"]');
                if (fullTitle) {
                    if (!input) {
                        input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'properties[Variant]';
                        form.appendChild(input);
                    }
                    input.value = fullTitle;
                } else if (input) {
                    // Без кастомного тайтла свойство не шлём вовсе (пустое "Variant: " в корзине не нужно)
                    input.remove();
                }
            });
        }

        // Инфографика под галереей (organo-republic-features): Seeds Included /
        // Bounty Harvest / Packet Price. Тексты предформатированы в Liquid.
        function applyStats(v) {
            var stats = (v && v.stats) || data.defaults.stats;
            if (!stats) return;

            var seedsEl = document.querySelector('[data-or-stat="seeds"]');
            if (seedsEl && stats.seedsText) seedsEl.textContent = stats.seedsText;

            var yieldEl = document.querySelector('[data-or-stat="yield"]');
            if (yieldEl && stats.yieldText) yieldEl.innerHTML = '<span>Up To</span> ' + stats.yieldText + 'lb';

            var packetEl = document.querySelector('[data-or-stat="packet-price"]');
            if (packetEl && stats.packetPriceText) packetEl.textContent = stats.packetPriceText;

            // Инфографика flowers-шаблона: площадь посева и число растений (вместо цены/урожая)
            var coverageEl = document.querySelector('[data-or-stat="coverage"]');
            if (coverageEl && stats.coverageText) coverageEl.innerHTML = '<span>Up To</span> ' + stats.coverageText + '&nbsp;<span>sq&nbsp;ft</span>';
            var plantsEl = document.querySelector('[data-or-stat="plants"]');
            if (plantsEl && stats.plantsText) plantsEl.textContent = stats.plantsText;

            // Числа в таблицах "Why We Are Better" (comparison-table / wbm-seeds):
            // спаны размечает snippets/or-wwab-feature.liquid.
            if (stats.seedsRaw != null) {
                document.querySelectorAll('[data-or-wwab="seeds"]').forEach(function (el) {
                    el.textContent = stats.seedsRaw;
                });
            }
            if (stats.perVarietyText) {
                document.querySelectorAll('[data-or-wwab="price-per-variety"]').forEach(function (el) {
                    el.textContent = stats.perVarietyText;
                });
            }
        }

        // Seeds Inside (слайдер + попап): состав выбранного варианта.
        // renderSeedsInside/renderSeedsInsidePopup и allSeeds — глобальные из inline-скрипта
        // product-page*.liquid; window.OrgoCurrentSeeds читает обработчик Compare (сравнение составов).
        function applySeeds(v) {
            var seeds = (v && v.seeds && v.seeds.length) ? v.seeds : null;
            window.OrgoCurrentSeeds = seeds; // null -> Compare возьмёт product-level список

            var target = seeds;
            if (!target && typeof allSeeds !== 'undefined' && allSeeds && allSeeds.length) target = allSeeds;
            if (!target || !target.length) return;

            if (typeof renderSeedsInside === 'function' && document.getElementById('seeds-inside-list')) {
                renderSeedsInside(target, 'seeds-inside-list');
            }
            if (typeof renderSeedsInsidePopup === 'function' && document.getElementById('seeds-inside-popup-list')) {
                renderSeedsInsidePopup(target, 'seeds-inside-popup-list');
            }
        }

        function applyVariant(variantId) {
            if (String(variantId) === String(appliedVariantId)) return;
            appliedVariantId = variantId;

            var v = data.variants[variantId];
            var fullTitle = (v && v.fullTitle) || null;
            // SEO-заголовок (перент + размер / кол-во сортов + перент) — собирается в or-variant-system.liquid;
            // fullTitle остаётся для корзины (properties[Variant])
            var displayTitle = (v && v.displayTitle) || null;

            document.querySelectorAll('[data-or-variant-title]').forEach(function (el) {
                el.textContent = displayTitle || data.defaults.title;
            });

            // Хлебные крошки: сегмент с коротким названием варианта ("1oz") после названия перента
            var crumb = document.querySelector('[data-or-breadcrumb-variant]');
            if (crumb && v && v.title) crumb.textContent = v.title;

            var descEl = document.querySelector('[data-or-variant-description]');
            if (descEl) {
                var html = (v && v.descriptionHtml) || '';
                descEl.innerHTML = html;
                descEl.style.display = html ? '' : 'none';
            }

            syncPropertyInputs(fullTitle);
            applyStats(v);
            applySeeds(v);

            // Generic-блоки контента по варианту (например, вкладка Seeds Inside в or-horizontal-tabs):
            // показываем блок с data-or-variant-content="<id>" выбранного варианта, остальные прячем
            document.querySelectorAll('[data-or-variant-content]').forEach(function (el) {
                el.style.display = String(el.getAttribute('data-or-variant-content')) === String(variantId) ? '' : 'none';
            });

            var gallery = galleryFor(variantId);

            // Фото в sticky-баре = первое фото галереи выбранного варианта
            // (галереи нет — default-галерея товара, т.е. прежнее главное фото).
            // Селектор скоуплен: класс or-sticky-cart-product-image используется и в попапе корзины.
            var stickyImg = document.querySelector('.or-sticky-cart-bottom .or-sticky-cart-product-image');
            if (stickyImg && gallery.images && gallery.images[0]) {
                // src 500x600 — тот же URL, что у первого слайда галереи (уже в кеше браузера)
                stickyImg.src = gallery.images[0].src;
                stickyImg.alt = displayTitle || data.defaults.title;
            }

            // Фото товара в секциях "Why We Are Better" (wbm-seeds, comparison-table) —
            // первое фото выбранного варианта (разметка: data-or-variant-photo)
            if (gallery.images && gallery.images[0]) {
                document.querySelectorAll('[data-or-variant-photo]').forEach(function (el) {
                    el.src = gallery.images[0].src;
                });
            }

            if (gallery.key !== currentGalleryKey) {
                rebuildGallery(gallery.images);
                currentGalleryKey = gallery.key;
            }

            document.dispatchEvent(new CustomEvent('or:variant:changed', {
                detail: { variantId: variantId, fullTitle: fullTitle }
            }));
        }

        // Properties для JS-путей добавления в корзину (jQuery-обработчик в product-page.liquid)
        window.OrgoVariantProperties = function (variantId) {
            var v = data.variants[variantId];
            return v && v.fullTitle ? { 'Variant': v.fullTitle } : null;
        };

        // Первое фото галереи варианта (для попапа корзины: /cart.js метаполей не отдаёт).
        // null — у варианта нет своей галереи, показывается стандартное item.image.
        window.OrgoVariantImage = function (variantId) {
            var v = data.variants[String(variantId)];
            return v && v.gallery && v.gallery.length ? v.gallery[0].src : null;
        };

        // Слушаем клики по тайлам вариантов (делегировано — сработает после
        // существующего обработчика цен, привязанного напрямую к тайлам).
        document.addEventListener('click', function (e) {
            if (!e.target.closest) return;
            var tile = e.target.closest('[data-variant-tiles] .organo-republic-variant-tile');
            if (!tile || tile.classList.contains('is-soldout') || tile.disabled) return;
            var id = tile.getAttribute('data-variant-id');
            if (id) applyVariant(id);
        });

        // ---------- Сравнение ВАРИАНТОВ между собой (кнопка Compare на карточке варианта) ----------
        // Использует попап .or-product-comparsion-popup и классы таблицы из product-page*.liquid
        // (та же вёрстка, что у сравнения с вариациями из custom.variations).
        function orValidSeeds(seeds) {
            return (seeds || []).filter(function (s) { return s && s.name && String(s.name).trim() !== ''; });
        }

        function orShowVariantComparison(currentId, otherId) {
            var table = document.getElementById('comparisonTable');
            var popup = document.querySelector('.or-product-comparsion-popup');
            var backdrop = document.querySelector('.or-product-comparsion-popup__backdrop');
            if (!table || !popup) return;

            var vCur = data.variants[String(currentId)] || {};
            var vOther = data.variants[String(otherId)] || {};
            // Состав текущей стороны: свой список варианта, иначе product-level allSeeds
            var curSeeds = orValidSeeds(vCur.seeds && vCur.seeds.length ? vCur.seeds : (typeof allSeeds !== 'undefined' ? allSeeds : []));
            var otherSeeds = orValidSeeds(vOther.seeds || []);

            var map = {};
            curSeeds.forEach(function (s) {
                map[s.name] = map[s.name] || { name: s.name, photo: s.photo, qty: s.qty };
                map[s.name].inCurrent = true;
            });
            otherSeeds.forEach(function (s) {
                map[s.name] = map[s.name] || { name: s.name, photo: s.photo, qty: s.qty };
                map[s.name].inOther = true;
            });
            var all = Object.keys(map).map(function (k) { return map[k]; }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            var curImg = galleryFor(String(currentId)).images[0];
            var otherImg = galleryFor(String(otherId)).images[0];
            var assets = data.assets || {};

            function featureItem(icon, text) {
                if (!icon) return '';
                return '<div class="organo-republic-comparsion-table-popup__features-list-item">' +
                    '<img class="organo-republic-comparsion-table-popup__features-list-item-icon" src="' + icon + '">' +
                    '<div class="organo-republic-comparsion-table-popup__features-list-item-text">' + text + '</div>' +
                '</div>';
            }

            var html = '' +
                '<div class="organo-republic-comparsion-table-popup__header-row">' +
                    '<div class="organo-republic-comparsion-table-popup__features-list">' +
                        featureItem(assets.germination, 'Up to 90% Germination') +
                        featureItem(assets.pure, 'Heirloom &amp; Non-GMO') +
                        featureItem(assets.americanFarm, 'Sourced in U.S.') +
                    '</div>' +
                    '<div class="organo-republic-comparsion-table-popup__or-pack-photo">' +
                        (curImg ? '<img src="' + curImg.src + '">' : '') +
                        '<div class="organo-republic-comparsion-table-popup-pack-name">' + escapeAttr(vCur.title || '') + '</div>' +
                    '</div>' +
                    '<div class="organo-republic-comparsion-table-popup__divider-center"></div>' +
                    '<div class="organo-republic-comparsion-table-popup__pack-photo">' +
                        (otherImg ? '<img src="' + otherImg.src + '">' : '') +
                        '<div class="organo-republic-comparsion-table-popup-pack-name">' + escapeAttr(vOther.title || '') + '</div>' +
                    '</div>' +
                    '<div class="organo-republic-comparsion-table-popup__divider-right"></div>' +
                '</div>' +
                '<div class="div-51 organo-republic-comparsion-table-popup__or-top-extension"></div>' +
                '<div class="div-53 organo-republic-comparsion-table-popup__other-top-extension"></div>';

            all.forEach(function (seed, i) {
                var isFirst = i === 0;
                var isLast = i === all.length - 1;
                var fl = (isFirst ? ' first' : '') + (isLast ? ' last' : '');
                html += '<div class="organo-republic-comparsion-table-popup__seed-row">' +
                    '<div class="div-' + (8 + i) + ' organo-republic-comparsion-table-popup__text' + fl + '">' +
                        '<img src="' + (seed.photo || 'https://placehold.co/36x36') + '">' + escapeAttr(seed.name) + ' <br> (' + (seed.qty || 0) + ' seeds)' +
                    '</div>' +
                    '<div class="div-' + (17 + i) + ' ' + (seed.inCurrent ? 'organo-republic-comparsion-table-popup__or-positive' : 'organo-republic-comparsion-table-popup__or-negative') + '">' + (seed.inCurrent ? '✔' : '✖') + '</div>' +
                    '<div class="div-' + (34 + i) + ' organo-republic-comparsion-table-popup__divider-center' + fl + '"></div>' +
                    '<div class="div-' + (25 + i) + ' ' + (seed.inOther ? 'organo-republic-comparsion-table-popup__other-positive' : 'organo-republic-comparsion-table-popup__other-negative') + '">' + (seed.inOther ? '✔' : '✖') + '</div>' +
                    '<div class="div-' + (43 + i) + ' organo-republic-comparsion-table-popup__divider-right' + fl + '"></div>' +
                '</div>';
            });

            html += '<div class="div-52 organo-republic-comparsion-table-popup__or-bottom-extension"></div>' +
                '<div class="div-54 organo-republic-comparsion-table-popup__other-bottom-extension"></div>' +
                '<div class="organo-republic-comparsion-table-popup__bottom-buttons-row">' +
                    '<div></div><div></div>' +
                    '<div class="div-55 comparsion-table-quick-add-to-cart" data-variant-id="' + escapeAttr(currentId) + '">' + (assets.bag ? '<img src="' + assets.bag + '">' : 'Add') + '</div>' +
                    '<div class="organo-republic-comparsion-table-popup__divider-center"></div>' +
                    '<div class="div-56 comparsion-table-quick-add-to-cart" data-variant-id="' + escapeAttr(otherId) + '">' + (assets.bag ? '<img src="' + assets.bag + '">' : 'Add') + '</div>' +
                    '<div class="organo-republic-comparsion-table-popup__divider-right"></div>' +
                '</div>';

            table.innerHTML = html;
            popup.classList.add('active');
            if (backdrop) backdrop.classList.add('active');
        }

        // Compare на capture-фазе: гасим клик, чтобы он не выбрал плитку
        document.addEventListener('click', function (e) {
            if (!e.target.closest) return;
            var btn = e.target.closest('[data-or-variant-compare]');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            var currentId = String(appliedVariantId || data.selectedId);
            orShowVariantComparison(currentId, btn.getAttribute('data-or-variant-compare'));
        }, true);

        // На загрузке: выбранный вариант может иметь свою галерею/описание
        if (data.selectedId) applyVariant(String(data.selectedId));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
